import React from 'react';
import './init';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import { TranslatorProvider } from '@front-activerse/common-components';
import translationsPlPL from './locales/pl-PL/translations.json';
import { AuthLoginByTokenContainer } from '@front-activerse/common-components';
import { Apollo } from '@front-activerse/common-components';

const translations = [{ lang: 'pl-PL', translation: translationsPlPL }];

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <Apollo>
      <TranslatorProvider fallbackLanguage="pl-PL" translations={translations}>
        <AuthLoginByTokenContainer>
          <App />
        </AuthLoginByTokenContainer>
      </TranslatorProvider>
    </Apollo>
  </StrictMode>
);
